import React, { useState, useEffect } from 'react';
import { ToggleButton } from '../../components/common';

type props = {
  status: boolean;
  initialstatus: boolean;
  id: string;
  buttonText: string;
  disableButton?: boolean;
  setStatus: (data: any) => void;
  Label: string;
  InnerComponent: React.ReactNode;
  onButtonClick?: any;
  enableAddButton?: any;
  disableToggleButton?: any;
};

const AccordionTile: React.FunctionComponent<props> = ({
  setStatus,
  Label,
  status,
  id,
  initialstatus,
  InnerComponent,
  buttonText,
  onButtonClick,
  disableButton,
  disableToggleButton,
}): JSX.Element => {
  const [dropDownState, setdropDownState] = useState<any>();

  useEffect(() => {
    if (status !== undefined && status !== null) {
      setdropDownState(status);
    }
  }, [status]);

  return (
    <div>
      <div className="gray-border-line relative flex w-full justify-between border-b py-3">
        <div className="text-gray-dark flex text-xl font-bold">
          <ToggleButton
            setStatus={setStatus}
            status={dropDownState}
            id={id}
            initialstatus={initialstatus}
            disabled={disableToggleButton}
          />
          {Label}
        </div>
        <div>
          <div className="w-full">
            {buttonText?.length > 0 && (
              <button
                disabled={!disableButton}
                className={
                  'h-6 w-full rounded-full px-2 text-center text-sm text-white ' +
                  (disableButton ? ' stacked-bar-blue-400' : ' bg-gray-background-light cursor-not-allowed')
                }
                onClick={onButtonClick}
              >
                {buttonText}
              </button>
            )}
          </div>
        </div>
      </div>
      <div className={'accordion-panel-close' + (status ? ' max-h-xlscreen accordion-panel' : ' max-h-0')}>
        {InnerComponent}
      </div>
    </div>
  );
};

export default AccordionTile;
